export const STALL_SAVE = 'STALL_SAVE';
export const STALL_SAVE_INFO = 'STALL_SAVE_INFO';

